import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {UtilService} from './util.service';
import {Observable} from 'rxjs/Observable';
import {StorageCompany} from '../model/StorageCompany';
import {StorageArticle} from '../model/StorageArticle';
import {StorageUser} from '../model/StorageUser';
import {StorageStorage} from '../model/StorageStorage';
import {StorageTransaction, StorageTransactionItemInfo} from '../model/StorageTransaction';

@Injectable()
export class StorageService {
  constructor(
    private httpClient: HttpClient,
    private utilService: UtilService
  ) {}

  private get(url_part: string) {
    return this.httpClient.get(this.utilService.getApiUrl(url_part));
  }

  private post(url_path: string, payload: any) {
    return this.httpClient.post(this.utilService.getApiUrl(url_path), payload);
  }

  private processResponse(response: any, converter: (any) => any) {
    if (response.status === 0) {
      return response.data.map(converter);
    } else {
      throw Observable.throw(response);
    }
  }

  getArticles(onlySN: boolean): Observable<StorageArticle[]> {
    return this.get('storage/articles?only_sn=' + (onlySN === true ? 'true' : 'false'))
      .map(
        (response: any) => {
          return this.processResponse(response, value => new StorageArticle(value));
        },
        (error: any) => {
          return error;
        }
      );
  }

  getCompanies(): Observable<StorageCompany[]> {
    return this.get('storage/companies')
      .map((response: any) => {
          return this.processResponse(response, value => new StorageCompany(value));
        },
        (error: any) => {
          return error;
        }
      );
  }

  getStorages(): Observable<StorageStorage[]> {
    return this.get('storage/')
      .map((response: any) => {
          return this.processResponse(response, value => new StorageStorage(value));
        },
        (error: any) => {
        return error;
        }
      );
  }

  getUserStorages(): Observable<StorageStorage[]> {
    return this.get('storage/user')
      .map(
        (response: any) => {
          return this.processResponse(response, value => new StorageStorage(value));
        },
        (error: any) => {
          return error;
        }
      );
  }

  getUsers(companyId): Observable<StorageUser[]> {
    return this.get('storage/company/' + companyId + '/users')
      .map(
        (response: any) => {
          return this.processResponse(response, value => new StorageUser(value));
        },
        (error: any) => {
          return error;
        }
      );
  }

  transferFromCompanyToUser(storageId: number, storageTransaction: StorageTransaction): Observable<any> {
    return this.post('storage/' + storageId + '/to_user', storageTransaction)
      .map(
        (response: any) => {
          if (response.status === 0) {
            return response.data;
          } else {
            throw Observable.throw(response);
          }
        },
        (error: any) => {
          return error;
        }
      );
  }

  transferFromUserToCompany(storageId: number, storageTransaction: StorageTransaction): Observable<any> {
    return this.post('storage/' + storageId + '/to_company', storageTransaction)
      .map(
        (response: any) => {
          if (response.status === 0) {
            return response.data;
          } else {
            throw Observable.throw(response);
          }
        },
        (error: any) => {
          return error;
        }
      );
  }

  updateCompanyItems(storageId: number, storageTransaction: StorageTransaction): Observable<any> {
    return this.post('storage/' + storageId + '/update_company_items', storageTransaction)
      .map(
        (response: any) => {
          if (response.status === 0) {
            return response.data;
          } else {
            throw Observable.throw(response);
          }
        },
        (error: any) => {
          return error;
        }
      );
  }

  getStorageItemInfos(storageId: number, companyId: number, userId: number): Observable<StorageTransactionItemInfo[]> {
    const userIdParam = userId ? '?user_id=' + userId : '';

    return this.get('storage/' + storageId + '/' + companyId + '/items' + userIdParam)
      .map(
        (response: any) => {
          if (response.status === 0) {
            return response.data;
          } else {
            throw Observable.throw(response);
          }
        },
        (error: any) => {
          return error;
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/storage.service.ts